import { FC, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { NavigatorUtils } from "~/application/utils";

export const ScrollToTop: FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    NavigatorUtils.scrollToTop();
  }, [pathname]);

  return null;
};

ScrollToTop.displayName = "ScrollToTop";
